import { render, staticRenderFns } from "./DomainOwnerList.vue?vue&type=template&id=62db495c&"
import script from "./DomainOwnerList.vue?vue&type=script&lang=js&"
export * from "./DomainOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./DomainOwnerList.vue?vue&type=style&index=0&id=62db495c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports